export const ActionTypes = Object.freeze({
  ADD_PRODUCT: "productsActions/ADD_PRODUCT",
  REMOVE_PRODUCT: "productsActions/REMOVE_PRODUCT",
  SET_PRODUCTS: "productsActions/SET_PRODUCTS",
  ADD_MULTIPLE_PRODUCTS: "productsActions/ADD_MULTIPLE_PRODUCTS",
  REMOVE_MULTIPLE_PRODUCTS: "productsActions/REMOVE_MULTIPLE_PRODUCTS",
});

export function addProduct(product, collectionId) {
  return {
    type: ActionTypes.ADD_PRODUCT,
    payload: {
      product,
      collectionId,
    },
  };
}

export function removeProduct(product, collectionId) {
  return {
    type: ActionTypes.REMOVE_PRODUCT,
    payload: {
      product,
      collectionId,
    },
  };
}

export function setProducts(products = [], collectionId) {
  return {
    type: ActionTypes.SET_PRODUCTS,
    payload: {
      products,
      collectionId,
    },
  };
}

export function addMultipleProducts(products) {
  return {
    type: ActionTypes.ADD_MULTIPLE_PRODUCTS,
    payload:products,
  };
}

export function removeMultipleProducts(products) {
  return {
    type: ActionTypes.REMOVE_MULTIPLE_PRODUCTS,
    payload:products,
  };
}



const ACTION_HANDLERS = { ActionTypes,
  addProduct,
  removeProduct,
  setProducts,
  addMultipleProducts,removeMultipleProducts }

export default ACTION_HANDLERS;